import React from "react";
import { Link } from "react-router-dom";

const STEPS = [
  "Disconnect Meta inside Azordi: Settings → Integrations → Meta ads → clear the token fields and Save. This removes the stored access token immediately.",
  "Remove Azordi from your Facebook account: Facebook → Settings & privacy → Settings → Business integrations (or Apps and websites) → Azordi → Remove.",
  "To delete your Azordi account and all data we hold (including any Meta campaign reporting we cached), email thenerdydermy@icloud.com from the account owner's email with the subject \"Delete my data\". We confirm within 2 business days and complete deletion within 30 days, except records we must keep for tax and legal reasons (invoices and payment records), which are retained only as long as the law requires.",
];

export default function DataDeletion() {
  return (
    <div className="min-h-screen bg-background text-foreground" data-testid="data-deletion-page">
      <header className="border-b border-border">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5"><img src="/azordi-logo.webp" alt="azordi" className="h-8 w-auto" /></Link>
          <Link to="/privacy" className="text-sm text-muted-foreground hover:text-foreground">Privacy policy</Link>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-4 sm:px-6 py-12 sm:py-16">
        <h1 className="font-heading font-extrabold text-3xl sm:text-4xl tracking-tight">Data deletion</h1>
        <p className="text-muted-foreground mt-3">How to remove the data Azordi holds about you or your clinic, including anything received from Facebook or Instagram (Meta).</p>
        <ol className="mt-10 space-y-6 list-decimal pl-6">
          {STEPS.map((t, i) => <li key={i} className="text-muted-foreground leading-relaxed" data-testid={`deletion-step-${i + 1}`}>{t}</li>)}
        </ol>
        <p className="text-muted-foreground mt-10 text-sm">Clients of a clinic: your clinic controls the records it stores in Azordi. Ask your clinic directly, or contact us and we will forward the request.</p>
      </main>
      <footer className="border-t border-border">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 py-8 text-center text-sm text-muted-foreground">Designed &amp; owned by The Nerdy Dermy · <Link to="/terms" className="hover:text-foreground">Terms</Link> · <Link to="/privacy" className="hover:text-foreground">Privacy</Link></div>
      </footer>
    </div>
  );
}
